import React from 'react';
import {WyscoutAnalyticsDashboard} from '@/features/players/wyscoutAnalyticsApi';

const count = (value: number | null, label: string): string => value === null ? `${label} not available` : `${value.toLocaleString('en-GB')} ${label}`;

const StatusPanels: React.FC<{data: WyscoutAnalyticsDashboard}> = ({data}) => (
  <div className="grid min-w-0 gap-3 md:grid-cols-2">
    <section aria-labelledby="analytics-selection-heading" className="min-w-0 rounded-lg bg-club-blue-50 p-4 ring-1 ring-club-blue-100 dark:bg-gray-800 dark:ring-gray-700">
      <h3 id="analytics-selection-heading" className="text-sm font-semibold text-gray-900 dark:text-gray-100">Selection summary</h3>
      <p className="mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100">{data.context.selectedMatches} {data.context.selectedMatches === 1 ? 'match' : 'matches'} selected</p>
      <p className="mt-1 break-words text-sm text-gray-600 dark:text-gray-300">
        {count(data.context.appearances, 'appearances')} · {count(data.context.starts, 'starts')} · {count(data.context.minutes, 'minutes')}
      </p>
    </section>
    <section aria-labelledby="analytics-coverage-heading" className="min-w-0 rounded-lg bg-gray-50 p-4 ring-1 ring-gray-200 dark:bg-gray-800 dark:ring-gray-700">
      <h3 id="analytics-coverage-heading" className="text-sm font-semibold text-gray-900 dark:text-gray-100">Data coverage</h3>
      <p className="mt-1 break-words text-sm text-gray-700 dark:text-gray-200">Locations available for {data.coverage.eventMatches} of {data.coverage.selectedMatches} matches</p>
      <p className="mt-1 break-words text-xs text-gray-500 dark:text-gray-400">Advanced statistics available for {data.coverage.advancedStatsMatches} of {data.coverage.selectedMatches} matches</p>
    </section>
  </div>
);

export default StatusPanels;
